/**
 * Command is a factory that produces concrete implementation of schedulable command
 *
 * A typical command is made up of "type", "scope", "target", "value", and "dryRun"
 *
 *
 * Example: "set config mapper {...}"
 *
 */
import Analyzer from './analyzer'
import Logger from './logger'

var GET = 'get'
var SET = 'set'
var COMMAND_TYPES = [GET, SET]

function parse() {
  var isValid = false
  var invalidCommand = {
    isValid,
    execute: () => null,
  }

  if (arguments.length < 2 || arguments.length > 5) {
    return invalidCommand
  }

  var type = arguments[0]

  if (!COMMAND_TYPES.includes(type)) {
    return invalidCommand
  }

  isValid = true

  var scope,
    target,
    value,
    dryRun = false
  if (arguments.length >= 2) {
    scope = arguments[1]
  }

  if (arguments.length >= 3) {
    target = arguments[2]
  }

  if (arguments.length >= 4) {
    value = arguments[3]
  }

  if (arguments.length >= 5) {
    dryRun = arguments[4]
  }

  // inject the implementation of executor into the result
  var execute = buildExecute(type, scope, target, value, dryRun)

  const result = {
    isValid,
    type,
    scope,
    target,
    value,
    execute,
  }

  return result
}

/**
 * Helper method to process a list of uninitialized commands.
 *
 * @param {Array} theQueue a list containing some uninitialized commands
 */
function parseQueue(theQueue) {
  if (!theQueue || typeof theQueue.length !== 'number' || theQueue.length === 0) {
    return []
  }

  return theQueue.map(args => parse(...args)).filter(command => command.isValid)
}

function buildExecute(type, scope, target, value, dryRun) {
  const context = {
    scope,
    target,
    value,
  }

  Logger.info(
    `command.js - buildExecute - build executor with type=${type},scope=${scope},target=${target},value=${value},dryRun=${dryRun}`
  )

  return function() {
    // swallow any unexpected error encountered during execution
    try {
      if (type === GET) {
        if (scope === 'config') {
          return Analyzer.getConfig({ target })
        }

        if (scope === 'element') {
          return Analyzer.getElement({ target })
        }

        if (scope === 'og::element') {
          return Analyzer.getOgElement({ target })
        }

        if (scope === 'css::element') {
          return Analyzer.getCssElement({ target })
        }

        if (scope === 'item') {
          return Analyzer.getItem({ target })
        }

        if (scope === 'css::item') {
          return Analyzer.getCssItem({ target })
        }

        if (scope === 'og::item') {
          return Analyzer.getOgItem({ target })
        }
      }

      if (type === SET) {
        if (scope === 'config') {
          return Analyzer.setConfig({ target, value, dryRun })
        }

        if (scope === 'css::element') {
          return Analyzer.setCssElement({ target, value, dryRun })
        }

        if (scope === 'og::element') {
          return Analyzer.setOgElement({ target, value, dryRun })
        }
      }
    } catch (error) {
      Logger.all(
        `execution error (type=${type},scope=${scope},target=${target},value=${value},dryRun=${dryRun}): ${error}`
      )
    }

    return Promise.resolve()
  }.bind(context)
}

export default {
  parse,
  parseQueue,
}
